import queryString from 'query-string';
import RequestGroupRebate from 'src/adminPanel/entities/articleManagement/RequestGroupRebate';
import callApi, { CallApiResult } from '.';

export const getGroupRebateByArticleTypeIdArticleGroupId = (
    articleTypeId: string,
    articleGroupId: string
): Promise<CallApiResult> => {
    let query = queryString.stringify({ articleTypeId, articleGroupId }, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;
    return callApi(`/api/groupRebate/list${query}`);
};

export const createNewArticleGroupGroupRebate = (groupRebateRequestDto: RequestGroupRebate): Promise<CallApiResult> => {
    return callApi('/api/groupRebate/add', { method: 'POST', data: groupRebateRequestDto });
};

export const updateArticleGroupGroupRebate = (groupRebateRequestDto: RequestGroupRebate): Promise<CallApiResult> => {
    return callApi('/api/groupRebate/update', { method: 'PUT', data: groupRebateRequestDto });
};

export const deleteArticleGroupGroupRebate = (
    articleTypeId: string,
    articleGroupId: string,
    minQuantity: string,
    premiumLevel: string
): Promise<CallApiResult> => {
    let query = queryString.stringify(
        { articleTypeId, articleGroupId, minQuantity, premiumLevel },
        { skipEmpty: true, skipNull: true }
    );
    if (query !== '') query = '?' + query;
    return callApi(`/api/groupRebate/delete${query}`, { method: 'DELETE' });
};
